import axios from '@/api/axios'
import urls from '@/api/url'
export default {
    signIn: (formData) =>
        axios.post(urls.signIn, formData), // 登录

    getValidata: (formData) =>
        axios.get(urls.validataUrl, formData),  // 获取验证码
    getorgDataList: (formData) => 
        axios.post(urls.orgDataList, formData), // 获取学校

    addRegister: (formData) =>
        axios.post(urls.addRegister, formData), // 注册

    sendCode: (formData) => 
        axios.post(urls.sendCodeUrl, formData), // 用户注册获取验证码

    Login: (formData) => 
        axios.post(urls.loginUrl, formData), // 登陆

    forgetPwd: (formData) =>
        axios.post(urls.forgetPwd, formData), // 忘记密码

    getToken: (formData) => 
        axios.post(urls.getToken, formData), // 获取token

    getTime: (formData) => 
        axios.post(urls.getTime, formData), // 获取次数

    userMock: (formData) =>
        axios.post(urls.userMock, formData), // 获取准考证号密码 模拟

    fixedPhoto: (formData) =>
        axios.post(urls.fixedPhoto, formData), // 重新上传照片

    userReal: (formData) =>
        axios.post(urls.userReal, formData), // 获取准考证号密码 考试

    getScoreList: (formData) =>
        axios.post(urls.getScoreList, formData), // 查询成绩

    getExamList: (formData) =>
        axios.post(urls.getExamList, formData), // 查询考试列表

    
}
